export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SERVICES = [
  { slug: "landing-page", name: "Landing Page", price: 500, weeks: 1, icon: "Rocket", desc: "High-converting pages with polished motion, built to launch fast." },
  { slug: "website", name: "Website", price: 800, weeks: 2, icon: "Globe", desc: "Multi-page marketing sites with CMS, SEO and smooth scrolling." },
  { slug: "ai-integration", name: "AI Integration", price: 500, weeks: 2, icon: "Sparkles", desc: "LLM chat, agents, RAG pipelines and automation wired into your product." },
  { slug: "dashboard", name: "Dashboard", price: 1000, weeks: 3, icon: "BarChart3", desc: "Realtime analytics dashboards your team uses every day." },
  { slug: "web-app", name: "Web App", price: 1200, weeks: 4, icon: "AppWindow", desc: "Full-stack applications with auth, payments and deployment included." },
  { slug: "mobile-app", name: "Mobile App", price: 1800, weeks: 5, icon: "Smartphone", desc: "Cross-platform iOS/Android apps with native feel and live sync." },
  { slug: "saas", name: "Full SaaS", price: 10000, weeks: 8, icon: "Cloud", desc: "Idea to revenue: multi-tenant SaaS with billing, admin and AI included." },
];

export const FEATURE_OPTIONS = [
  { name: "Auth & Accounts", price: 800, weeks: 0.5 },
  { name: "Payments", price: 1200, weeks: 1 },
  { name: "AI Chat / Agents", price: 1500, weeks: 1 },
  { name: "CMS", price: 900, weeks: 0.5 },
  { name: "Analytics", price: 1000, weeks: 1 },
  { name: "SEO Setup", price: 400, weeks: 0 },
];

export const TIMELINES = ["ASAP (Rush)", "2-4 weeks", "1-2 months", "3+ months"];

export const PROJECTS = [
  {
    slug: "tune4tune",
    title: "Tune4Tune",
    subtitle: "Custom Dubplate Marketplace",
    category: "Fullstack SaaS",
    image: "/img/work/tune4tune.webp",
    gallery: [
      "/img/work/tune4tune.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/0kuoplo5_Screenshot%202026-09-01%20at%2010.54.20%E2%80%AFAM.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/4l1r5z1q_Screenshot%202026-09-01%20at%2010.54.33%E2%80%AFAM.webp",
    ],
    desc: "Custom dubplates from top Caribbean Dancehall and Reggae artists. Personalized voiceovers, shoutouts and drops recorded on your riddim of choice, with an in-browser recording studio built for the artists themselves.",
    tech: ["Stripe Payments", "Artist Dashboard + Spotify Links", "Audio Upload / Download", "In-Browser Studio + Decibel Meter"],
    metrics: "49+ TOP ARTISTS / 24H AVG RESPONSE / LIVE IN PRODUCTION",
    live: "https://tune4tune.com",
    span: "lg:col-span-12",
  },
  {
    slug: "freightkpi",
    title: "Freight KPI",
    subtitle: "Freight Forwarding Ops Dashboard",
    category: "Dashboards",
    image: "/img/work/freightkpi.webp",
    gallery: [
      "/img/work/freightkpi.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/i5pi4uhr_Screenshot%202026-09-01%20at%2011.28.49%E2%80%AFAM.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/5412mv80_Screenshot%202026-09-01%20at%2011.37.20%E2%80%AFAM.webp",
    ],
    desc: "Operations dashboard for a Miami freight forwarding company. Tracks every package across the Doral and Medley warehouses: processed, shipped and delivered counts, end-of-day totals, and automated daily reports.",
    tech: ["Admin + Manager Roles", "Daily Entry Logging", "PDF / CSV Export", "Email Reports"],
    metrics: "2 WAREHOUSES / 3.6K+ PACKAGES TRACKED DAILY / IN PRODUCTION",
    span: "lg:col-span-7",
  },
  {
    slug: "execlens",
    title: "ExecLens",
    subtitle: "CEO Intelligence Dashboard",
    category: "Fullstack SaaS / Dashboard",
    tags: ["Fullstack SaaS", "Dashboards"],
    image: "/img/work/execlens.webp",
    gallery: [
      "/img/work/execlens.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/e4dlrh7k_Screenshot%202026-09-01%20at%201.48.04%E2%80%AFPM.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/i13ejpqw_Screenshot%202026-09-01%20at%201.48.47%E2%80%AFPM.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/u3kszrud_Screenshot%202026-09-01%20at%201.46.48%E2%80%AFPM.webp",
    ],
    desc: "CEO tool that reads company email and turns it into a daily briefing. Summarizes each department, surfaces pain points, and shows which customers need attention, which workers are overloaded, and which tasks are dragging. Built on a RAG system so company data stays secure.",
    tech: ["RAG Secure Data Layer", "Email Intelligence", "Department Summaries", "Daily CEO Briefing"],
    metrics: "READS COMPANY EMAIL / RAG-SECURED / NEEDS-ATTENTION ALERTS",
    span: "lg:col-span-5",
  },
  {
    slug: "purseimburse",
    title: "PurseImburse",
    subtitle: "AI Expense Tracker",
    category: "Web App",
    image: "/img/work/purseimburse.webp",
    gallery: [
      "/img/work/purseimburse.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/sn2f24i7_PurseImburse%20%E2%80%94%20Quarterly%20expense%20tracker%202.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/fymoqb6n_PurseImburse%20%E2%80%94%20Quarterly%20expense%20tracker.webp",
    ],
    desc: "Expense tracker built for a non profit in Jamaica. Took staff expense reporting off paper: photograph a receipt and AI reads it, extracts the details and files the expense, so travel and lodging costs are never retyped and staff are reimbursed at the end of each quarter.",
    tech: ["AI Receipt Reader", "Google + Email Auth", "Quarterly Reimbursements", "JMD Currency"],
    metrics: "PAPER-FREE REPORTING / AI RECEIPT SCANNING / IN PRODUCTION",
    live: "https://purseimburse.com",
    span: "lg:col-span-7",
  },
  {
    slug: "mira",
    title: "Mira",
    subtitle: "AI Personal Concierge",
    category: "Mobile App",
    image: "/img/work/mira.webp",
    gallery: [
      "/img/work/mira.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/p3jtkyfw_Screenshot%202026-09-01%20at%201.24.54%E2%80%AFPM.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/ma1k0r7i_Screenshot%202026-09-01%20at%201.25.12%E2%80%AFPM.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/10wcrgr8_Screenshot%202026-09-01%20at%201.22.06%E2%80%AFPM.webp",
      "https://customer-assets-agu9un31.emergentagent.net/job_devfolio-services/artifacts/b2pp9tzm_Screenshot%202026-09-01%20at%201.21.29%E2%80%AFPM.webp",
    ],
    desc: "Personal assistant built to make women's lives easier by automating their plans. Mira learns routines like hair, nails and wax, checks the calendar and asks before a slot slips by. One tap and the AI books the appointment with the business by text, email or WhatsApp, then adds it to the in-app calendar.",
    tech: ["Calendar Scanning", "Proactive Appointment Prompts", "AI Booking via Text / Email / WhatsApp", "In-App AI Assistant"],
    metrics: "AI CONCIERGE / HANDS-FREE BOOKING",
    span: "lg:col-span-5",
  },
];

export const PROJECT_FILTERS = ["All", "Fullstack SaaS", "Dashboards", "Web App", "Mobile App"];
